(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["build-your-own"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.dh-byo').forEach(initBYO);

    function initBYO(section) {
      if (section.dataset.dhInit === '1') return;
      section.dataset.dhInit = '1';

      const sectionId = section.dataset.sectionId;
      const storageKey = 'dh-byo-' + sectionId;
      // selections shape:
      // { frame: {...product}, top: {...product}, accessories: { [productId]: {...product} } }
      const selections = loadSelections();

      // Reveal observer
      const revealObs = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              revealObs.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 }
      );
      section.querySelectorAll('[data-reveal]').forEach((el) => revealObs.observe(el));

      // Wire steps
      section.querySelectorAll('.dh-byo__step').forEach((stepEl) => {
        const stepKey = stepEl.dataset.step;
        const mode = stepEl.dataset.stepMode || 'single';
        const cards = stepEl.querySelectorAll('[data-product]');

        cards.forEach((card) => {
          const variants = parseVariants(card);
          const optionSelects = card.querySelectorAll('[data-option-select], .dh-byo__option-select');

          // Stop dropdown clicks from triggering the card select button
          optionSelects.forEach((sel) => {
            sel.addEventListener('click', (e) => e.stopPropagation());
            sel.addEventListener('change', () => {
              updateCardVariant(card, variants);
              // If this card is currently selected, push the updated variant info
              if (card.classList.contains('is-selected')) {
                const data = readCardData(card, variants);
                if (mode === 'multi') {
                  if (!selections.accessories) selections.accessories = {};
                  selections.accessories[data.id] = data;
                } else {
                  selections[stepKey] = data;
                }
                saveSelections();
                refreshStep(stepEl, stepKey, mode);
                updateSummary();
              }
            });
          });

          // Initialize price/variant display from default selection
          updateCardVariant(card, variants);

          const selectBtn = card.querySelector('[data-select]');
          if (selectBtn) {
            selectBtn.addEventListener('click', () => {
              const data = readCardData(card, variants);
              // Block selecting a sold-out variant entirely
              if (data.available === false) return;
              toggleSelection(stepKey, mode, data, card);
            });
          }

          // Quantity stepper wiring — stops clicks from selecting the card, clamps 1..max
          const qty = card.querySelector('[data-qty]');
          if (qty) {
            const input = qty.querySelector('[data-qty-value]');
            const dec = qty.querySelector('[data-qty-decrement]');
            const inc = qty.querySelector('[data-qty-increment]');
            const max = Number(input.max) || 10;
            const min = Number(input.min) || 1;

            function syncQty(next, opts) {
              const n = Math.max(min, Math.min(max, Math.floor(Number(next) || min)));
              input.value = String(n);
              card.dataset.quantity = String(n);
              if (dec) dec.disabled = n <= min;
              if (inc) inc.disabled = n >= max;
              // If this product is currently in the build, push updated qty into selections.
              if (!opts || opts.silent !== true) {
                if (mode === 'multi' && selections.accessories && selections.accessories[card.dataset.productId]) {
                  selections.accessories[card.dataset.productId].quantity = n;
                  saveSelections();
                  updateSummary();
                } else if (mode !== 'multi' && selections[stepKey] && String(selections[stepKey].id) === String(card.dataset.productId)) {
                  selections[stepKey].quantity = n;
                  saveSelections();
                  updateSummary();
                }
              }
            }

            qty.addEventListener('click', (e) => e.stopPropagation());
            if (dec) dec.addEventListener('click', () => syncQty((Number(input.value) || min) - 1));
            if (inc) inc.addEventListener('click', () => syncQty((Number(input.value) || min) + 1));
            input.addEventListener('click', (e) => e.stopPropagation());
            input.addEventListener('input', () => syncQty(input.value));
            input.addEventListener('blur', () => syncQty(input.value));

            syncQty(input.value, { silent: true });
          }
        });

        // Single-step clear
        const clearBtn = stepEl.querySelector('[data-clear]');
        if (clearBtn) {
          clearBtn.addEventListener('click', () => clearSingle(stepKey));
        }

        // Restore previous selections
        refreshStep(stepEl, stepKey, mode);
      });

      // Frame leg-count filter pills
      const frameStep = section.querySelector('.dh-byo__step[data-step="frame"]');
      if (frameStep) {
        const filterBtns = Array.from(frameStep.querySelectorAll('.dh-byo__filter'));
        const frameGrid = frameStep.querySelector('.dh-byo__grid');
        const frameGridWrap = frameStep.querySelector('.dh-byo__grid-wrap');
        const allCards = Array.from(frameStep.querySelectorAll('[data-product]'));

        function countMatches(filter) {
          if (!filter || filter === 'all') return allCards.length;
          return allCards.reduce((n, card) => {
            const tags = (card.dataset.tags || '').split(/\s+/).filter(Boolean);
            return n + (tags.indexOf(filter) !== -1 ? 1 : 0);
          }, 0);
        }


        function setActiveBtn(btn) {
          filterBtns.forEach((b) => {
            const on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-selected', on ? 'true' : 'false');
          });
        }

        function ensureNoResultsEl() {
          let el = frameGridWrap && frameGridWrap.querySelector('[data-no-results]');
          if (!el && frameGridWrap) {
            el = document.createElement('div');
            el.className = 'dh-byo__no-results';
            el.setAttribute('data-no-results', '');
            el.innerHTML = '<strong>No frames match this filter.</strong><span>Try a different leg count.</span>';
            frameGridWrap.appendChild(el);
          }
          return el;
        }

        // Per-filter cap — honors the "Frames shown" theme setting on each card.
        const perFilterLimit = (() => {
          const fromCard = allCards.find((c) => c.dataset.frameLimit);
          const n = fromCard ? Number(fromCard.dataset.frameLimit) : 6;
          return Number.isFinite(n) && n > 0 ? n : 6;
        })();

        function applyFrameFilter(filter) {
          let shown = 0;
          allCards.forEach((card) => {
            const tags = (card.dataset.tags || '').split(/\s+/).filter(Boolean);
            const matchesFilter = !filter || filter === 'all' || tags.indexOf(filter) !== -1;
            const withinCap = shown < perFilterLimit;
            const visible = matchesFilter && withinCap;
            card.classList.toggle('is-hidden', !visible);
            if (visible) shown++;
          });

          const noResults = ensureNoResultsEl();
          if (noResults) noResults.hidden = shown > 0;
          if (frameGrid) frameGrid.hidden = shown === 0;
        }

        filterBtns.forEach((btn) => {
          btn.addEventListener('click', () => {
            setActiveBtn(btn);
            applyFrameFilter(btn.dataset.filter);
          });
        });

        // On load: pick the first filter that actually has matching products.
        // Falls back to the first pill if none match (e.g. tags missing entirely),
        // and shows the no-results empty state instead of an empty grid.
        const initiallyActive = frameStep.querySelector('.dh-byo__filter.is-active') || filterBtns[0];
        let chosen = initiallyActive;
        if (initiallyActive && countMatches(initiallyActive.dataset.filter) === 0) {
          const firstWithMatches = filterBtns.find((b) => countMatches(b.dataset.filter) > 0);
          if (firstWithMatches) chosen = firstWithMatches;
        }
        if (chosen) {
          setActiveBtn(chosen);
          applyFrameFilter(chosen.dataset.filter);
        }
      }

      // Final CTA — add frame + top + every selected accessory to the Shopify cart
      const cta = section.querySelector('[data-summary-cta]');
      if (cta) {
        const ctaLabelEl = cta.querySelector('.dh-byo__cta-button-label') || cta;
        const originalLabel = ctaLabelEl.textContent;

        function setCtaState(state, message) {
          cta.dataset.state = state;
          if (message) ctaLabelEl.textContent = message;
          if (state === 'loading') {
            cta.setAttribute('aria-busy', 'true');
            cta.disabled = true;
          } else {
            cta.removeAttribute('aria-busy');
          }
        }

        function resetCta(delay) {
          window.setTimeout(() => {
            ctaLabelEl.textContent = originalLabel;
            cta.dataset.state = '';
            cta.disabled = false;
          }, delay || 1800);
        }

        function qtyFor(productId) {
          // Read live quantity off the card so the user's stepper value is always honored.
          if (!productId) return 1;
          const card = section.querySelector('[data-product][data-product-id="' + productId + '"]');
          if (!card) return 1;
          const n = Number(card.dataset.quantity || (card.querySelector('[data-qty-value]') || {}).value || 1);
          return Math.max(1, Math.floor(n) || 1);
        }

        function collectItems() {
          const items = [];
          if (selections.frame && selections.frame.variantId) {
            items.push({
              id: Number(selections.frame.variantId),
              quantity: qtyFor(selections.frame.id),
            });
          }
          if (selections.top && selections.top.variantId) {
            items.push({
              id: Number(selections.top.variantId),
              quantity: qtyFor(selections.top.id),
            });
          }
          const acc = selections.accessories || {};
          Object.values(acc).forEach((item) => {
            if (item && item.variantId) {
              items.push({
                id: Number(item.variantId),
                quantity: qtyFor(item.id),
              });
            }
          });
          return items;
        }

        cta.addEventListener('click', async () => {
          if (cta.disabled) return;
          const items = collectItems();
          if (!items.length) return;

          setCtaState('loading', 'Adding to cart…');

          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify({ items }),
            });

            if (!res.ok) {
              const errBody = await res.json().catch(() => ({}));
              // Shopify returns the offending variant_id on stock errors — map it back to product title.
              const failedVariantId = errBody.variant_id || (errBody.errors && errBody.errors.variant_id);
              let soldOutTitle = '';
              if (failedVariantId) {
                const all = [selections.frame, selections.top]
                  .concat(Object.values(selections.accessories || {}))
                  .filter(Boolean);
                const hit = all.find((s) => Number(s.variantId) === Number(failedVariantId));
                if (hit) soldOutTitle = hit.title;
              }
              const raw = errBody.description || errBody.message || ('HTTP ' + res.status);
              const friendly = /sold[\s\-]?out|stock|inventory|not enough/i.test(raw)
                ? (soldOutTitle ? soldOutTitle + ' is sold out' : 'An item in your bundle is sold out')
                : raw;
              const e = new Error(friendly);
              e.soldOut = /sold[\s\-]?out|stock|inventory|not enough/i.test(raw);
              throw e;
            }

            // Notify other cart UIs (drawer, count badge, etc.) so they refresh.
            document.dispatchEvent(new CustomEvent('dh:cart:updated', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            window.dispatchEvent(new CustomEvent('cart:updated'));

            setCtaState('success', 'Added — opening cart…');

            // Give cart drawers a moment to refresh, then send the user to /cart.
            window.setTimeout(() => {
              window.location.href = '/cart';
            }, 600);
          } catch (err) {
            console.error('[dh-byo] cart add failed', err);
            const msg = err && err.message ? err.message : 'Couldn\u2019t add — try again';
            setCtaState('error', msg);
            resetCta(3200);
          }
        });
      }

      function parseVariants(card) {
        const node = card.querySelector('script[data-variants]');
        if (!node) return null;
        try {
          return JSON.parse(node.textContent);
        } catch (e) {
          return null;
        }
      }

      function readCardData(card, variants) {
        const defaultVariantId = card.dataset.defaultVariantId
          ? Number(card.dataset.defaultVariantId)
          : null;
        // Treat a card as available unless BOTH flags explicitly say sold out.
        // This avoids false positives when an attribute is missing or empty.
        const variantFlag = card.dataset.defaultVariantAvailable;
        const productFlag = card.dataset.productAvailable;
        const explicitlySoldOut = variantFlag === 'false' && productFlag === 'false';
        const defaultAvailable = !explicitlySoldOut;
        const base = {
          id: card.dataset.productId,
          handle: card.dataset.productHandle,
          title: card.dataset.productTitle,
          image: card.dataset.productImage,
          price: card.dataset.productPrice,
          url: card.dataset.productUrl,
          variantId: defaultVariantId,
          variantTitle: '',
          options: [],
          available: defaultAvailable,
        };
        if (variants && variants.length) {
          const chosen = card.querySelectorAll('.dh-byo__option-select');
          const optionValues = Array.from(chosen).map((s) => s.value);
          const match = variants.find((v) =>
            v.options.every((opt, i) => opt === optionValues[i])
          );
          if (match) {
            base.variantId = match.id;
            base.variantTitle = match.title;
            base.options = optionValues;
            base.price = match.price;
            base.available = match.available !== false;
            if (match.image) base.image = match.image;
          }
        }
        return base;
      }

      function updateCardVariant(card, variants) {
        const data = readCardData(card, variants || []);
        const priceEl = card.querySelector('.dh-byo__card-price');
        if (priceEl && data.price && variants && variants.length) {
          priceEl.innerHTML = '<span class="dh-byo__card-price-now">' + data.price + '</span>';
        }
        const imgEl = card.querySelector('.dh-byo__card-media img');
        if (imgEl && data.image && variants && variants.length) {
          if (imgEl.src !== data.image) {
            imgEl.src = data.image;
            imgEl.removeAttribute('srcset');
          }
        }
        // Reflect availability on the card + badge + select button
        const soldOut = data.available === false;
        card.classList.toggle('is-soldout', soldOut);
        const badge = card.querySelector('[data-soldout-badge]');
        if (badge) badge.hidden = !soldOut;
        const selectBtn = card.querySelector('[data-select]');
        if (selectBtn) {
          selectBtn.setAttribute('aria-disabled', soldOut ? 'true' : 'false');
        }
      }

      function toggleSelection(stepKey, mode, data, card) {
        if (mode === 'multi') {
          if (!selections.accessories) selections.accessories = {};
          if (selections.accessories[data.id]) {
            delete selections.accessories[data.id];
          } else {
            selections.accessories[data.id] = data;
          }
        } else {
          // Toggle off if same product clicked again
          if (selections[stepKey] && selections[stepKey].id === data.id) {
            delete selections[stepKey];
          } else {
            selections[stepKey] = data;
          }
        }
        saveSelections();
        const stepEl = card.closest('.dh-byo__step');
        refreshStep(stepEl, stepKey, mode);
        updateSummary();
      }

      function clearSingle(stepKey) {
        delete selections[stepKey];
        saveSelections();
        const stepEl = section.querySelector('.dh-byo__step[data-step="' + stepKey + '"]');
        if (stepEl) refreshStep(stepEl, stepKey, 'single');
        updateSummary();
      }

      function refreshStep(stepEl, stepKey, mode) {
        const cards = stepEl.querySelectorAll('[data-product]');

        if (mode === 'multi') {
          const selectedMap = selections.accessories || {};
          const count = Object.keys(selectedMap).length;

          cards.forEach((card) => {
            const isOn = !!selectedMap[card.dataset.productId];
            card.classList.toggle('is-selected', isOn);
            const btn = card.querySelector('[data-select]');
            if (btn) btn.setAttribute('aria-checked', isOn ? 'true' : 'false');
          });

          stepEl.classList.toggle('is-complete', count > 0);
          const statusText = stepEl.querySelector('.dh-byo__status-text');
          if (statusText) statusText.textContent = count > 0 ? count + ' added' : 'None added';

          const list = stepEl.querySelector('[data-preview-list]');
          const empty = stepEl.querySelector('[data-preview-empty]');
          const itemsEl = stepEl.querySelector('[data-preview-items]');
          const countEl = stepEl.querySelector('[data-preview-count]');

          if (count === 0) {
            if (list) list.hidden = true;
            if (empty) empty.style.display = '';
          } else {
            if (empty) empty.style.display = 'none';
            if (list) list.hidden = false;
            if (countEl) countEl.textContent = count;
            if (itemsEl) {
              itemsEl.innerHTML = '';
              Object.values(selectedMap).forEach((item) => {
                const li = document.createElement('li');
                li.className = 'dh-byo__preview-item';
                li.innerHTML =
                  '<img src="' + escapeAttr(item.image || '') + '" alt="" loading="lazy" />' +
                  '<div class="dh-byo__preview-item-body">' +
                    '<span class="dh-byo__preview-item-title">' + escapeHtml(item.title) + '</span>' +
                    (item.variantTitle && item.variantTitle !== 'Default Title'
                      ? '<span class="dh-byo__preview-item-variant">' + escapeHtml(item.variantTitle) + '</span>'
                      : '') +
                  '</div>' +
                  '<span class="dh-byo__preview-item-price">' + (item.price || '') + '</span>' +
                  '<button type="button" class="dh-byo__preview-item-remove" data-remove-id="' + escapeAttr(item.id) + '" aria-label="Remove ' + escapeAttr(item.title) + '">' +
                    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
                  '</button>';
                itemsEl.appendChild(li);
              });
              itemsEl.querySelectorAll('[data-remove-id]').forEach((btn) => {
                btn.addEventListener('click', () => {
                  const id = btn.getAttribute('data-remove-id');
                  if (selections.accessories) delete selections.accessories[id];
                  saveSelections();
                  refreshStep(stepEl, stepKey, mode);
                  updateSummary();
                });
              });
            }
          }
        } else {
          const sel = selections[stepKey];
          cards.forEach((card) => {
            const isOn = !!(sel && sel.id === card.dataset.productId);
            card.classList.toggle('is-selected', isOn);
            const btn = card.querySelector('[data-select]');
            if (btn) btn.setAttribute('aria-checked', isOn ? 'true' : 'false');
          });

          stepEl.classList.toggle('is-complete', !!sel);

          const statusText = stepEl.querySelector('.dh-byo__status-text');
          if (statusText) statusText.textContent = sel ? 'Selected' : 'Not selected';

          const card = stepEl.querySelector('[data-preview-card]');
          const empty = stepEl.querySelector('[data-preview-empty]');
          if (sel) {
            if (empty) empty.style.display = 'none';
            if (card) {
              card.hidden = false;
              const img = card.querySelector('[data-preview-img]');
              const title = card.querySelector('[data-preview-title]');
              const variant = card.querySelector('[data-preview-variant]');
              const price = card.querySelector('[data-preview-price]');
              if (img) { img.src = sel.image || ''; img.alt = sel.title || ''; }
              if (title) title.textContent = sel.title || '';
              if (variant) variant.textContent = (sel.variantTitle && sel.variantTitle !== 'Default Title') ? sel.variantTitle : '';
              if (price) price.innerHTML = sel.price || '';
            }
          } else {
            if (card) card.hidden = true;
            if (empty) empty.style.display = '';
          }
        }
      }

      function updateSummary() {
        let total = 0;
        const soldOutSelections = [];

        // Frame
        setSummaryItem('frame', selections.frame, 'Not selected');
        if (selections.frame) {
          total += parsePrice(selections.frame.price);
          if (selections.frame.available === false) soldOutSelections.push('Frame');
        }

        // Top
        setSummaryItem('top', selections.top, 'Not selected');
        if (selections.top) {
          total += parsePrice(selections.top.price);
          if (selections.top.available === false) soldOutSelections.push('Top');
        }

        // Accessories (multi)
        const accMap = selections.accessories || {};
        const accValues = Object.values(accMap);
        const accItem = section.querySelector('[data-summary-step="accessories"]');
        const accValueEl = accItem ? accItem.querySelector('[data-summary-value]') : null;
        const accSoldOutEl = accItem ? accItem.querySelector('[data-summary-soldout]') : null;
        if (accValues.length === 0) {
          if (accItem) accItem.classList.add('is-empty');
          if (accItem) accItem.classList.remove('is-soldout');
          if (accValueEl) accValueEl.textContent = 'None added';
          if (accSoldOutEl) accSoldOutEl.hidden = true;
        } else {
          if (accItem) accItem.classList.remove('is-empty');
          if (accValueEl) {
            accValueEl.textContent = accValues.length === 1
              ? accValues[0].title
              : accValues.length + ' items';
          }
          accValues.forEach((a) => { total += parsePrice(a.price); });
          const soldAcc = accValues.filter((a) => a.available === false);
          if (accItem) accItem.classList.toggle('is-soldout', soldAcc.length > 0);
          if (accSoldOutEl) {
            accSoldOutEl.hidden = soldAcc.length === 0;
            if (soldAcc.length > 0) {
              accSoldOutEl.textContent = soldAcc.length === 1
                ? 'Sold out: ' + soldAcc[0].title
                : soldAcc.length + ' accessories sold out';
              soldOutSelections.push('Accessories');
            }
          } else if (soldAcc.length > 0) {
            soldOutSelections.push('Accessories');
          }
        }

        const totalEl = section.querySelector('[data-summary-total]');
        if (totalEl) totalEl.textContent = formatPrice(total);

        const hasSoldOut = soldOutSelections.length > 0;
        const cta = section.querySelector('[data-summary-cta]');
        if (cta) {
          // Require frame + top, and no sold-out items in the bundle
          cta.disabled = !(selections.frame && selections.top) || hasSoldOut;
        }

        // Update helper copy next to the CTA
        const helper = section.querySelector('[data-cta-helper]');
        if (helper) {
          helper.classList.toggle('is-warning', hasSoldOut);
          if (hasSoldOut) {
            helper.textContent = 'Some items in your bundle are sold out — swap them to continue';
          } else if (!selections.frame && !selections.top) {
            helper.textContent = 'Pick a frame and top to continue';
          } else if (!selections.frame) {
            helper.textContent = 'Pick a frame to continue';
          } else if (!selections.top) {
            helper.textContent = 'Pick a top to continue';
          } else {
            const accCount = Object.keys(selections.accessories || {}).length;
            helper.textContent = accCount > 0
              ? 'Ready — ' + accCount + (accCount === 1 ? ' accessory' : ' accessories') + ' added'
              : 'Ready to build';
          }
        }
      }

      function setSummaryItem(key, sel, emptyText) {
        const item = section.querySelector('[data-summary-step="' + key + '"]');
        if (!item) return;
        const valueEl = item.querySelector('[data-summary-value]');
        const soldEl = item.querySelector('[data-summary-soldout]');
        if (sel) {
          item.classList.remove('is-empty');
          if (valueEl) valueEl.textContent = sel.title;
          const soldOut = sel.available === false;
          item.classList.toggle('is-soldout', soldOut);
          if (soldEl) {
            soldEl.hidden = !soldOut;
            if (soldOut) soldEl.textContent = 'Sold out';
          }
        } else {
          item.classList.add('is-empty');
          item.classList.remove('is-soldout');
          if (valueEl) valueEl.textContent = emptyText;
          if (soldEl) soldEl.hidden = true;
        }
      }

      function parsePrice(str) {
        if (!str) return 0;
        const n = parseFloat(String(str).replace(/[^0-9.\-]/g, ''));
        return isNaN(n) ? 0 : n;
      }

      function formatPrice(n) {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
            style: 'currency',
            currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
          }).format(n);
        } catch (e) {
          return '$' + n.toFixed(2);
        }
      }

      function loadSelections() {
        try {
          const raw = sessionStorage.getItem(storageKey);
          const parsed = raw ? JSON.parse(raw) : {};
          if (!parsed.accessories) parsed.accessories = {};
          return parsed;
        } catch (e) {
          return { accessories: {} };
        }
      }
      function saveSelections() {
        try {
          sessionStorage.setItem(storageKey, JSON.stringify(selections));
        } catch (e) {}
      }

      function escapeHtml(str) {
        return String(str == null ? '' : str)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');
      }
      function escapeAttr(str) { return escapeHtml(str); }

      updateSummary();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
